 
import React from "react";
import { Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import UndoIcon from "@mui/icons-material/Undo";
import StatusBadge from "./StatusBadge";
import "./EmployeeTableForDepartments.css";
 
const EmployeeTableForDepartments = ({
  employees = [],
  currentRows = [],
  onDelete,
  onUndo,
  page = 1,
  rowsPerPage = 10,
}) => {
  const safePage = Number(page) || 1;
  const safeRowsPerPage = Number(rowsPerPage) || 10;
 
  return (
    <Box sx={{  mt: 2 }}>
      <table
        className="pd-table"
        style={{
          width: "100%",
          tableLayout: "auto",
          borderCollapse: "collapse"
        }}
      >

        <thead>
          <tr>
            <th style={{ width: "80px" }}>S.No</th>
            <th style={{ width: "150px" }}>Employee Name</th>
            <th style={{ width: "120px" }}>Department</th>
            <th style={{ width: "100px" }}>Status</th>
            <th style={{ width: "80px" }}>Action</th>
          </tr>
        </thead>
 
        <tbody>
          {currentRows.length > 0 ? (
            currentRows.map((emp, index) => (
              <tr
                key={emp.id || index}
                style={{
                  opacity: !emp.isDeleted && emp.assessmentStatus === "Available" ? 1 : 0.5,
                  backgroundColor: !emp.isDeleted && emp.assessmentStatus === "Available" ? "inherit" : "#f5f5f5",
                }}
              >
                <td>{(safePage - 1) * safeRowsPerPage + index + 1}</td>
                <td
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {emp.employeeName}
                </td>
                <td>{emp.departmentName || "None"}</td>
                <td>
                  <StatusBadge status={emp.assessmentStatus || "Available"} />
                </td>
                <td>
                  {emp.isDeleted ? (
                    <button
                      className="action-icon"
                      onClick={() => onUndo(emp.id)}
                      title="Undo"
                    >
                      <UndoIcon fontSize="small" />
                    </button>
                  ) : (
                    <button
                      className="action-icon"
                      onClick={() => onDelete(emp.id)}
                      title="Delete"
                    >
                      <DeleteIcon fontSize="small" />
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" align="center">
                No employees in Departments Selected
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  );
};
 
export default EmployeeTableForDepartments;
 
